module.exports = __webpack_public_path__ + "img/Ambilight.aadb3acd.jpg";